import {Component, EventEmitter, HostListener, Inject, Input, OnInit, Output} from '@angular/core';
import {
  DEFAULT_PAGE_INDEX,
  DEFAULT_PAGE_SIZE,
  EventItem, ListSortOrder,
  Lookups,
  PagedFilter, Pages,
  RaceRegistration, RegistrationFilter,
  StatementImportItem,
  TypeOfRegistration
} from "@model";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {RegistrationDetailsModalComponent} from "@components";
import {TranslocoService} from "@ngneat/transloco";
import {DOCUMENT} from "@angular/common";
import {RaceService} from "@services";

@Component({
  selector: 'app-event-management-registrations-list',
  templateUrl: './event-management-registrations-list.component.html',
  styleUrl: './event-management-registrations-list.component.scss'
})
export class EventManagementRegistrationsListComponent implements OnInit {
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) eventItem?: EventItem;
  @Input({required: true}) raceRegistrations: RaceRegistration[] = [];
  @Input({required: true}) disableRegisterToRace: boolean = false;
  @Input({required: true}) hasMore: boolean = false;
  @Input({required:true}) raceRegistrationsPage:number = DEFAULT_PAGE_INDEX;
  @Output() registerToRace: EventEmitter<void> = new EventEmitter<void>();
  @Output() getFileFromServer: EventEmitter<string> = new EventEmitter<string>();
  @Output() onHasMore: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onRaceRegistrations: EventEmitter<RaceRegistration[]> = new EventEmitter<RaceRegistration[]>();
  @Output() onRaceRegistrationsPage: EventEmitter<number> = new EventEmitter<number>();

  showFabButton: boolean = false;
  isLoading:boolean = false;

  constructor(private modalService: NgbModal, private translocoService: TranslocoService,
              @Inject(DOCUMENT) private document: Document, private raceService: RaceService) {
  }

  ngOnInit(): void {
    if (this.raceRegistrationsPage === DEFAULT_PAGE_INDEX) {
      this.handleRaceRegistrationExploreResult(this.raceRegistrations);
    }
  }


  onRegisterToRace() {
    this.registerToRace.next();
  }
  onGetFileFromServer(type:string) {
    this.getFileFromServer.next(type);
  }

  registrationDetails(raceRegistration: RaceRegistration) {
    const modalRef: NgbModalRef = this.modalService.open(RegistrationDetailsModalComponent, {
      centered: true,
      windowClass: 'registration-details-modal',
    });
    modalRef.componentInstance.title = this.translocoService.translate("account.statements.registration.details");
    modalRef.componentInstance.raceRegistration = raceRegistration;
    modalRef.componentInstance.languages = this.languages;

    modalRef.result.then((_:StatementImportItem) => {
    }, (_) => {
      /// ignore
    });
  }

  @HostListener('window:scroll')
  toggleFabButton(): void {
    this.showFabButton = window.pageYOffset != 0;
  }

  scrollToTop(): void {
    return this.document.body.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start'
    });
  }

  handleRaceRegistrationExploreResult(value: RaceRegistration[], loadMore?: boolean): void {
    if (value) {
      if (value.length > DEFAULT_PAGE_SIZE) {
        value = (value.slice(0, DEFAULT_PAGE_SIZE))
        this.onHasMore.next(true);
      } else {
        this.onHasMore.next(false);
      }
      if (loadMore && this.raceRegistrations) {
        value = this.raceRegistrations.concat(value)
      }
    }
    this.listOfRaceRegistrationsChanged(value);
  }

  listOfRaceRegistrationsChanged(value: RaceRegistration[] | null) {
    if (value && value.length > 0) {
      this.onRaceRegistrations.next(value);
      this.onRaceRegistrationsPage.next(this.raceRegistrationsPage+1);
    } else {
      this.onRaceRegistrations.next([]);
    }
  }

  onLoadMore() {
    this.onRaceRegistrationsExplore(true);
  }

  onRaceRegistrationsExplore(loadMore?: boolean): void {
    if (loadMore !== true) {
      this.raceRegistrationsPage = 1;
    }
    let pagedFilter: PagedFilter<RegistrationFilter> = new PagedFilter(new Pages(undefined, this.raceRegistrationsPage), new RegistrationFilter(undefined, undefined, this.eventItem?.id, undefined),
      ListSortOrder.DESC);
    this.isLoading = loadMore ? this.isLoading : true;
    this.raceService.findMatchingRegistrations(pagedFilter).subscribe((value: RaceRegistration[]) => {
        setTimeout(() => {
          this.isLoading = loadMore ? this.isLoading : false;
        }, 300);
        this.handleRaceRegistrationExploreResult(value, loadMore);
      }
    )
  }

  protected readonly TypeOfRegistration = TypeOfRegistration;
  protected readonly RaceRegistration = RaceRegistration;
}
